import React, { useRef } from 'react';
import './RichTextEditor.css';

const RichTextEditor = ({ label, value, onChange, placeholder, minHeight = 180 }) => {
  const editorRef = useRef(null);

  const runCommand = (command, commandValue = null) => {
    if (!editorRef.current) return;
    editorRef.current.focus();
    document.execCommand(command, false, commandValue);
    onChange(editorRef.current.innerHTML);
  };

  const insertImage = () => {
    const imageUrl = window.prompt('Afbeelding URL plakken:');
    if (!imageUrl) return;
    runCommand('insertImage', imageUrl);
  };

  const handleInput = (e) => {
    onChange(e.currentTarget.innerHTML);
  };

  return (
    <div className="rte-group">
      {label && <label className="rte-label">{label}</label>}
      <div className="rte-toolbar" role="toolbar" aria-label={`${label || 'Editor'} toolbar`}>
        <button type="button" onClick={() => runCommand('bold')} className="rte-btn" title="Bold">B</button>
        <button type="button" onClick={() => runCommand('italic')} className="rte-btn" title="Italic"><i>I</i></button>
        <button type="button" onClick={() => runCommand('underline')} className="rte-btn" title="Underline"><u>U</u></button>
        <button type="button" onClick={() => runCommand('formatBlock', 'H1')} className="rte-btn" title="Heading 1">H1</button>
        <button type="button" onClick={() => runCommand('formatBlock', 'H2')} className="rte-btn" title="Heading 2">H2</button>
        <button type="button" onClick={() => runCommand('insertUnorderedList')} className="rte-btn" title="Bullets">• List</button>
        <button type="button" onClick={() => runCommand('insertOrderedList')} className="rte-btn" title="Numbers">1. List</button>
        <button type="button" onClick={() => runCommand('createLink', window.prompt('Link URL:') || '')} className="rte-btn" title="Insert link">Link</button>
        <button type="button" onClick={insertImage} className="rte-btn" title="Insert image">Image</button>
        <button type="button" onClick={() => runCommand('removeFormat')} className="rte-btn" title="Clear format">Clear</button>
      </div>

      <div
        ref={editorRef}
        className="rte-editor"
        contentEditable
        suppressContentEditableWarning
        onInput={handleInput}
        data-placeholder={placeholder || ''}
        style={{ minHeight: `${minHeight}px` }}
        dangerouslySetInnerHTML={{ __html: value || '' }}
      />
    </div>
  );
};

export default RichTextEditor;
